




































import { Action } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';
import API from '@/Api';

const namespace: string = 'EmployeeStore';

@Component
export default class UpcomingBirthdayList extends Vue {
    @Prop() public showAllBtn!: boolean;
    @Action('getSearchProfile', { namespace }) public getSearchProfile!: any;
    public items: any[] =  [];
    public colors: string[] = [ 'cyan', 'light-green', 'light-blue', 'indigo', 'orange'];

    public mounted() {
      const url = this.showAllBtn === true ? '/api/upcoming-birthdays' : '/api/upcoming-birthdays?all=true';
      API.Instance
        .get(url)
        .then((response) => {
          this.items = response.data;
        });
    }

    public handleItemClick(id: any) {
      this.$router.push({name: 'profile', params: {id}}, () => {
            this.getSearchProfile(id);
        });
    }

    public handleAllClick() {
      this.$router.push({name: 'upcoming-birthdays'});
    }
}
